<div class="container">
  <div class="action-bar">
    <button id="reset-color-filters" type="button" mat-flat-button color="accent" (click)="resetFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>
    <button
      id="save-wheel-color"
      type="button"
      mat-flat-button
      color="primary"
      (click)="save()"
      [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
      [disabled]="!isSaveEnabled || !this.canEditWheelColor"
    >
      <mat-icon>save</mat-icon>
      {{ translationService.translate('saveLinkText') || 'Save' }}
    </button>
    <button
      id="add-wheel-color"
      type="button"
      mat-flat-button
      color="primary"
      (click)="addRow()"
      [disabled]="!this.canEditWheelColor"
      [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
    >
      <mat-icon>add</mat-icon>
      {{ translationService.translate('addWheelColorText') || 'Add Wheel Color' }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="wheelColorCodeDropdown"
          label="{{ translationService.translate('codeText') }}"
          emptyPlaceholder="{{ translationService.translate('selectCodeText') || 'Select Code' }}"
          placeholder="{{ translationService.translate('selectCodeText') || 'Select Code' }}"
          [formGroup]="filterForm"
          formControlName="wheelColorCodes"
          [data]="wheelColorCodeFilterList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="wheelColorDescDropdown"
          label="{{ translationService.translate('descriptionText') }}"
          emptyPlaceholder="{{ translationService.translate('selectDescText') || 'Select Description' }}"
          placeholder="{{ translationService.translate('selectDescText') || 'Select Description' }}"
          [formGroup]="filterForm"
          formControlName="wheelColorDescriptions"
          [data]="wheelColorDescriptionFilterList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="wheel-color-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'wheelColorCode'">
        <input type="text" matInput maxlength="20" [formControl]="getControl(item, 'wheelColorCode')" />
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'wheelColorDescription'">
        <input type="text" matInput maxlength="50" [formControl]="getControl(item, 'wheelColorDescription')" />
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'action'">
        <button mat-icon-button class="btn-delete" [disabled]="!canEditWheelColor" (click)="showDeleteModal(item)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </ng-container>
    </mic-table>
  </div>
  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>{{
    translationService.translate('deleteWheelColorConfirmText') || 'Are you sure you want to delete this Wheel Color?'
  }}</ng-template>
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
